@if (!skeletonView) {
  <div class="grid">
    <div [matTooltip]="'ORDERS.COMMON.RECIPIENT.name_tooltip' | translate" class="info-row">
      <mat-icon class="contact-icon" color="primary">person</mat-icon>
      @if (order.recipient.name; as name) {
        <span>{{ name }}</span>
      } @else {
        <app-colorized-text>{{ 'ORDERS.COMMON.RECIPIENT.no_name' | translate }}</app-colorized-text>
      }
    </div>
    <div [matTooltip]="'ORDERS.COMMON.RECIPIENT.phone_tooltip' | translate" class="info-row">
      <mat-icon class="contact-icon" color="primary">phone</mat-icon>
      @if (order.recipient.phone; as phone) {
        <span>{{ phone }}</span>
      } @else {
        <app-colorized-text>{{ 'ORDERS.COMMON.RECIPIENT.no_phone' | translate }}</app-colorized-text>
      }
    </div>
    <div [matTooltip]="'ORDERS.COMMON.RECIPIENT.email_tooltip' | translate" class="info-row">
      <mat-icon class="contact-icon" color="primary">email</mat-icon>
      @if (order.recipient.email; as email) {
        <span>{{ email }}</span>
      } @else {
        <app-colorized-text>{{ 'ORDERS.COMMON.RECIPIENT.no_email' | translate }}</app-colorized-text>
      }
    </div>
    <div [matTooltip]="'ORDERS.COMMON.RECIPIENT.address_tooltip' | translate" class="info-row">
      <mat-icon class="contact-icon" color="primary">home</mat-icon>
      @if (address) {
        <span>{{ address }}</span>
      } @else {
        <app-colorized-text>{{ 'ORDERS.COMMON.RECIPIENT.no_address' | translate }}</app-colorized-text>
      }
    </div>
  </div>
} @else {
  <div class="grid">
    <ngx-skeleton-loader [count]="3" [theme]="{ marginBottom: '5px' }"></ngx-skeleton-loader>
    <ngx-skeleton-loader [count]="1" [theme]="{ height: '30px', margin: '0' }"></ngx-skeleton-loader>
  </div>
}
